import {axiosGetHandler, axiosPostHandler} from './config'
import store from "@/store";
import {extractAPIValues} from '_lib/utils/utils'
const {BASE_API, BASE_XHH} = extractAPIValues()

let ws_id_promise = null

/**
 * @description: 获取ws唯一id标识
 * @param {*} args
 * @param {Boolean} force 如果要覆盖ws_id传force=true(目前只有socket重连时需要)
 * @return {Promise<Object>}
 */
export function getWsId (args, force) {
	var url = BASE_API + '/chatroom/v2/account/ws_id'
	if (force) {
		ws_id_promise = null
	}
	if (!ws_id_promise) {
		ws_id_promise = axiosGetHandler(url, args).then(res => {
			if (res.data.status == 'ok') {
				store.commit(force ? 'SET_WS_ID_FORCE' : 'SET_WS_ID', res.data.result.ws_id)
			}
			return res
		})
	}
	return ws_id_promise
}

// 更新个人信息
export function updateProfile (args, formdata) {
	let url = BASE_XHH + '/account/update_profile/'
	return axiosPostHandler(url, args, formdata)
}

// 获取个人信息
export function getAccountInfo (args, formdata) {
	let url = BASE_XHH + '/account/info/'
	return axiosGetHandler(url, args, formdata)
}

// 获取个人权限信息(手机号)
export function getAuthInfo (args, formdata) {
	let url = BASE_XHH + '/account/get_auth_info/'
	return axiosGetHandler(url, args, formdata)
}

// 获取用户右键菜单信息
export function getProfileInfo (args, formdata) {
	let url = BASE_API + '/chatroom/v2/account/profile'
	return axiosGetHandler(url, args, formdata)
}

/**
 * 获取手机绑定验证码
 * @param { * } args 
 * @param { phone_num } formdata 加密过的带国家代码的手机号
 * @returns 
 */
export function getPhoneNumCode (args, formdata) {
	let url = BASE_XHH + '/account/get_phonenum_code/'
	return axiosPostHandler(url, args, formdata)
}

/**
 * 获取手机号SID
 * @param { code } args 验证码
 * @param { phone_num } formdata 加密过的带国家代码的手机号
 * @returns { result: { sid } }
 */
export function getPhoneNumSid (args, formdata) {
	let url = BASE_XHH + '/account/get_phonenum_sid/'
	return axiosPostHandler(url, args, formdata)
}

// 检查账户状态
export function checkAccountState (args, formdata) {
	let url = BASE_XHH + '/account/check_account_state/'
	return axiosPostHandler(url, args, formdata)
}

// 绑定手机号
export function bindPhoneNum (args, formdata) {
	var url = BASE_XHH + '/account/web_bind_phonenum'
	return axiosPostHandler(url, args, formdata)
}

/**
 * 更换手机号绑定
 * @param { sid, sid_new } args 
 * @param { phone_num, phone_num_new } formdata 
 * @returns 
 */
export function replaceBindPhoneNum (args, formdata) {
	let url = BASE_XHH + '/account/replace_bind_phonenum/'
	return axiosPostHandler(url, args, formdata)
}

// 获取用户游戏id
export function getUserGameIds (args) {
	var url = BASE_API + '/chatroom/v2/account/user_game_ids'
	return axiosGetHandler(url, args)
}

// 解绑游戏账号
export function unbindGameAccount (args) {
	var url = BASE_XHH + '/account/unbind_game_id/'
	return axiosGetHandler(url, args)
}

// 获取用户卡片设置
export function getUserCardSetting (args) {
	var url = BASE_API + '/chatroom/v2/account/card/setting'
	return axiosGetHandler(url, args)
}

// 更新或者插入新的card
export function upsertCard (args, formdata) {
	var url = BASE_API + '/chatroom/v2/account/card/upsert'
	return axiosPostHandler(url, args, formdata)
}

// 用户卡片排序
export function updateCardSort (args, formdata) {
	var url = BASE_API + '/chatroom/v2/account/card/sort'
	return axiosPostHandler(url, args, formdata)
}

// 用户卡片删除
export function deleteCard (args, formdata) {
	var url = BASE_API + '/chatroom/v2/account/card/del'
	return axiosPostHandler(url, args, formdata)
}
// 用户卡片解绑
export function unbindCard (args, formdata) {
	var url = BASE_API + '/chatroom/v2/account/game/unbind'
	return axiosPostHandler(url, args, formdata)
}

// 对任意用户设置备注
/* 
* @param {String} heybox_id
* @param {String} remarks
*/
export function setRemarks(args, formdata) {
  let url = BASE_API + '/chatroom/v2/friend/remarks'
	return axiosPostHandler(url, args, formdata)
}

// 设置新密码
export function setNewPassword (args, formdata) {
  let url = BASE_XHH + '/account/modify_pwd_without_pwd/'
  return axiosPostHandler(url, args, formdata)
}

// 修改密码
export function replacePassword (args, formdata) {
  let url = BASE_XHH + '/account/modify_pwd_with_old_pwd/'
  return axiosPostHandler(url, args, formdata)
}

// 获取自己游戏状态
export function getSelfGameState (args) {
	let url = BASE_API + '/chatroom/v2/account/game_state'
	return axiosGetHandler(url, args)
}

// 获取所有边框列表
export function getBorderList (args) {
  let url = BASE_API + '/chatroom/v2/account/card_border/list_user'
	return axiosGetHandler(url, args)
}

// 获取用户登录装置
export function getUserDevices (args) {
  let url = BASE_API + '/chatroom/v2/account/device/list'
	return axiosGetHandler(url, args)
}

// 移除用户登录设备
export function removeUserDevice (args, formdata) {
  let url = BASE_API + '/chatroom/v2/account/device/delete'
	return axiosPostHandler(url, args, formdata)
}

// 更新用户卡片信息
export function updateUserCard (args, formdata) {
  let url = BASE_API + '/chatroom/v2/account/user_card/edit'
	return axiosPostHandler(url, args, formdata)
}

// 获取用户升级任务
export function getUserLevelTasks (args) {
  let url = BASE_API + '/chatroom/v2/task/user_tasks'
	return axiosGetHandler(url, args)
}

// 解除绑定微信号
export function unbindWechat (args, formdata) {
  let url = BASE_XHH + '/account/unbind_wechat_account/'
	return axiosPostHandler(url, args, formdata)
}

// 编辑个人卡片描述
export function editUserIntro (args, formdata) {
	let url = BASE_API + '/chatroom/v2/account/intro/edit'
	return axiosPostHandler(url, args, formdata)
}

//获取用户邀新用户列表
export function getUserInviteList (args) {
  let url = BASE_API + '/chatroom/v2/common/invite_new/list'
	return axiosGetHandler(url, args)
}

// 获取绑定的Steam账号列表
export function getSteamBindList (args) {
	let url = BASE_XHH + '/account/bind_steam_accounts_info'
	return axiosGetHandler(url, args)
}

// 设置steam主账号
export function setSteamMaster (args, formdata) {
	let url = BASE_XHH + '/account/change_account'
	return axiosPostHandler(url, args, formdata)
}

// 刷新steam账号数据
export function refreshSteamAccountInfo (args) {
	const url = BASE_XHH + '/account/refresh_steam_stats/'
	return axiosGetHandler(url, args)
}

// 轮询Steam账号数据刷新状态
export function pollingSteamRefreshState (args, formdata) {
	return new Promise((resolve, reject) => {
		const url = BASE_XHH + '/account/get_refreshing_state/'
		const maxRetries = 6
    polling(url, args, formdata, resolve, reject, maxRetries)
  })
}

function polling(url, arg, formdata, resolve, reject, retries) {
	if (retries <= 0) {
		reject('已超时,请稍后手动刷新页面查看');
    return;
  }
  axiosPostHandler(url, arg, formdata).then((res) => {
		if (res.data.status == 'ok') {
			let { state } = res.data.result
			if (state == 'ok') {
				resolve()
			} else if (['waiting', 'updating'].includes(state)) {
				setTimeout(() => {
					polling(url, arg, formdata, resolve, reject, retries - 1)
				}, 1500)
			} else {
				reject()
			}
		} else {
			reject(res.data.msg)
		}
	})
}

// 获取Steam个人隐私公开状态
export function getSteamPublicState (args) {
	return new Promise((resolve, reject) => {
		const url = BASE_XHH + '/account/public_steam_settings/'
		axiosGetHandler(url, args).then((res) => {
			if (res.data.status === 'ok') {
				let url = res.data.result.games_url
				window.electronAPI.sendRequest({
					url,
					method: 'GET',
					params: {},
					body: {},
					base: 'external',
					headers: {
						'Accept': 'text/html,application/xhtml+xml,application/xml;q=0.9,*/*;q=0.8',
					}
				}).then((res) => {
					if (res.response && res.response.games) {
						resolve(true)
					} else {
						resolve(false)
					}
				}).catch((error) => {
					console.log(error)
					reject()
				})
			}
		}).catch((error) => {
			reject()
		})
  })
}

// 修改用户外观
export function editDecoration (args, formdata) {
	let url = BASE_API + '/chatroom/v2/account/decoration'
	return axiosPostHandler(url, args, formdata)
}

// 实名认证
export function verified (args, formdata) {
	let url = BASE_XHH + '/heybox/open/user/certification'
	return axiosPostHandler(url, args, formdata)
}

// 获取登录token
export function getWebToken (args) {
	let url = BASE_XHH + '/account/gen_token_for_web_login/'
	return axiosGetHandler(url, args)
}

// 修改展示房间
export function updateShowRoom(args, formdata) {
	let url = BASE_API + '/chatroom/v2/account/showing_room'
	return axiosPostHandler(url, args, formdata)
}

export function updateBilibiliLivingState(args) {
	let url = BASE_API + '/chatroom/v2/account/bili'
	return axiosGetHandler(url, args)
}

// 获取上传文件大小size
export function getAccountUploadFileLimit() {
	let url = BASE_API + '/chatroom/v2/settings/account/upload_file_size'
	return axiosGetHandler(url)
}

// 获取和某个用户的共同经历
export function getTogetherInfo (args) {
	var url = BASE_API + '/chatroom/v2/account/shared_experience'
	return axiosGetHandler(url, args)
}

// 注销账号
export function deregisterAccount(args = {}, formdata) {
	let url = BASE_XHH + '/account/written_off_account/'
	return axiosPostHandler(url, args, formdata)
}

/**
 * 同步小黑盒App绑定游戏
 */
export function syncFightCardsFromHeybox() {
	let url = BASE_XHH + '/chatroom/v2/account/sync_card'
	return axiosPostHandler(url, {}, {})
}

/**
 * 获取安全认证URL
 */
export function getSecurityVerifyProtocol(args) {
	let url = BASE_XHH + '/msg/user/need_verify'
	return axiosGetHandler(url, args)
}